import { rootApi } from '../../user/api';

// Define a service using a base URL and expected endpoints
const apiWithTag = rootApi.enhanceEndpoints({
  addTagTypes: ['Configuration'],
});

export const configurationApi = apiWithTag.injectEndpoints({
  endpoints: (builder) => ({
    findAllConfiguration: builder.query({
      query: () => `dm_configurations/`,
      providesTags: ['Configuration'],
    }),
    findConfigurationById: builder.query({
      query: (id) => `dm_configurations/${id}/`,
      providesTags: (result, error, arg) => {
        return result
          ? [{ type: 'Configuration', id: result.id }]
          : ['Configuration'];
      },
    }),
    updateConfiguration: builder.mutation({
      query: (configuration) => ({
        url: `dm_configurations/${configuration.id}/`,
        method: 'PUT',
        body: { value: configuration.value },
      }),
      invalidatesTags: ['Configuration'],
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useFindAllConfigurationQuery,
  useFindConfigurationByIdQuery,
  useUpdateConfigurationMutation,
} = configurationApi;
